window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.choiceAsAccordion = function (parent, shared) {
    const _logger = window.mcb.utilities.createLogger("forms.field.accordion", 'Forms Field (Accordion)');
    const _thisField = parent;
    const _shared = shared;
    let _validatedControlWrapper = null;
    const _controls = [];
    let _validationCanvas = null;

    {
        // Init
        _thisField.validation = {
            required: _thisField.settings.required ?? false,
            isSingleRequired: _thisField.settings.data.choices.length === 1 && _thisField.settings.required && _thisField.settings.title === null,
            dirty: false,
        };

        _thisField.rendering = {
            isHorizontal: typeof _thisField.settings.data.horizontal === "boolean" && _thisField.settings.data.horizontal === true
        }
    }

    const render = function (fieldGroup) {
        fieldGroup.classList.add(window.mcb.forms.constants.fields.classBaseDashed + 'accordion');

        const wrapper = document.createElement('div');
        wrapper.classList.add(window.mcb.forms.constants.fields.collectionClass);
        wrapper.classList.add('accordion');
        wrapper.classList.add('accordion-flush');
        wrapper.id = _thisField.fieldValuewrapperId;

        if (_thisField.settings.required) {
            wrapper.classList.add(window.mcb.forms.constants.fields.requiredClass);
        }

        let index = 0;
        for (let choice of _thisField.settings.data.choices) {
            const item = document.createElement('div');
            item.classList.add('accordion-item');
            wrapper.append(item);

            const title = document.createElement('h4');
            title.classList.add('accordion-header');
            title.id = _thisField.fieldValueControlId + '_title_' + index;
            item.append(title);

            const input = document.createElement('input');
            input.name = _thisField.alias;
            input.id = _thisField.fieldValueControlId + '_radio_' + index;
            input.type = 'radio';
            input.tabIndex = -1;
            input.checked = choice.value === _thisField.settings.defaultValue;
            if (input.checked) {
                _thisField.validation.dirty = true;
            }

            input.value = choice.value;
            input.dataset.caption = choice.caption;
            input.classList.add(window.mcb.forms.constants.fields.accordionSelectionClass);
            title.append(input);

            const button = document.createElement('button');
            button.classList.add(window.mcb.forms.constants.fields.uiInput);
            button.classList.add('accordion-button');
            button.classList.add('collapsed');
            button.type = 'button';
            button.dataset.bsToggle = 'collapse';
            button.dataset.bsTarget = '#' + _thisField.fieldValueControlId + '_collapse_' + index;
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-controls', _thisField.fieldValueControlId + '_collapse_' + index);
            button.innerText = choice.caption;
            title.append(button);

            const canvas = document.createElement('div');
            canvas.id = _thisField.fieldValueControlId + '_collapse_' + index;
            canvas.classList.add('accordion-collapse');
            canvas.classList.add('collapse');
            canvas.setAttribute('aria-labelledby', _thisField.fieldValueControlId + '_title_' + index);
            canvas.dataset.bsParent = '#' + _thisField.fieldValueControlId;
            canvas.addEventListener('show.bs.collapse', function (event) {
                for (let i = 0; i < _controls.length; i++) {
                    if (_controls[i].accordion === event.target) {
                        _controls[i].checkbox.checked = true;
                    }
                    else {
                        // Disable others
                        bootstrap.Collapse.getOrCreateInstance(_controls[i].accordion, { toggle: false }).hide();
                    }
                }

                _shared.validateEvent(event, _thisField, event.target);
                _shared.fireFieldModifiedEvents(event.target, _thisField.applyValidationDuringInput);
            });

            canvas.addEventListener('hide.bs.collapse', function (event) {
                for (let i = 0; i < _controls.length; i++) {
                    if (_controls[i].accordion === event.target) {
                        _controls[i].checkbox.checked = false;
                        _shared.validateEvent(event, _thisField, event.target);
                        _shared.fireFieldModifiedEvents(event.target, _thisField.applyValidationDuringInput);
                    }
                }
            });

            const body = document.createElement('div');
            body.classList.add('accordion-body');
            canvas.append(body);

            item.append(canvas);

            index++;
            _controls.push({
                checkbox: input,
                accordion: canvas,
            });

            input.addEventListener('focus', (event) => {
                _shared.validateEvent(event, _thisField, input);
                _shared.fireFieldModifiedEvents(input, _thisField.applyValidationDuringInput);
            });

            input.addEventListener('change', (event) => {
                _shared.validateEvent(event, _thisField, input);
                _shared.fireFieldModifiedEvents(input, _thisField.applyValidationDuringInput);
            });

            input.addEventListener('blur', (event) => {
                _shared.validateEvent(event, _thisField, input);
                _shared.fireFieldModifiedEvents(input, _thisField.applyValidationDuringInput);
            });
        }

        _validationCanvas = document.createElement('div');
        _validationCanvas.classList.add(window.mcb.forms.constants.validation.validationTarget);

        _validatedControlWrapper = document.createElement('div');
        _validatedControlWrapper.classList.add(window.mcb.forms.constants.validation.validationWrapper);

        _validatedControlWrapper.appendChild(wrapper);
        _validatedControlWrapper.appendChild(_validationCanvas);

        return _validatedControlWrapper;
    };

    const getValue = function () {
        window.mcb.forms.validation.clearValidationResults(_validationCanvas);

        if (_validationCanvas === null) {
            throw new Error("Control is not initialized");
        }

        for (let i = 0; i < _controls.length; i++) {
            if (document.getElementById(_controls[i].checkbox.id) === null) {
                throw new Error("Control has been removed from DOM");
            }
        }

        if (_validationCanvas.offsetParent === null) {
            // Field is not visible
            return undefined;
        }

        const values = [];
        for (let i = 0; i < _thisField.settings.data.choices.length; i++) {
            if (_controls[i].checkbox.checked) {
                values.push(_thisField.settings.data.choices[i].value);
            }
        }

        var value = values.join('|');

        const validation = new window.mcb.forms.validation.ValidationResult(true);
        if (_thisField.validation.required === true) {
            validation.aggregate(new window.mcb.forms.validation.validateRequired(_thisField.alias, value));
        }

        if (values.length > 1) {
            validation.aggregate(new window.mcb.forms.validation.ValidationResult(false, "ChoiceHasTooManyValues", values));
        }

        validation.render(_thisField.formId, _validatedControlWrapper, _validationCanvas);
        if (validation.isValid()) {
            return value;
        }

        return null;
    };

    const setValue = function (value) {
        let isSet = false;
        for (let i = 0; i < _controls.length; i++) {
            if (value === _controls[i].checkbox.value) {
                bootstrap.Collapse.getOrCreateInstance(_controls[i].accordion, { toggle: true });
                isSet = true;
                break;
            }
        }

        return isSet;
    }

    const onRendered = function () {
        if (typeof bootstrap !== "undefined") {
            for (let i = 0; i < _controls.length; i++) {
                if (_controls[i].checkbox.checked) {
                    bootstrap.Collapse.getOrCreateInstance(_controls[i].accordion, { toggle: true });
                    _shared.fireFieldModifiedEvents(_controls[i].checkbox, true);
                }
            }
        }
        else {
            _logger.log("Bootstrap not found, waiting...");
            bootstrapDelay = setTimeout(onRendered, 50);
        }
    }

    return _ = {
        render: render,
        onRendered: function () {
            if (_thisField.validation.dirty) {
                onRendered();
            }

            return;
        },
        getValue: getValue,
        setValue: setValue
    };
};
